module.exports = __webpack_public_path__ + "img/incubator-2.4651de29.jpg";